import { BaseModel } from "@blue-chip/core";

export default class Country extends BaseModel {}
